import React from "react";
import LogoIcon from "../../../assets/Dashboard/logo2.svg";

const Logo = () => {
  return (
    <div className="smai-sidebar-logo">
      <div className="smai-logo-icon" style={{ width: "100%", height: "auto" }}>
        <img
          src={LogoIcon}
          alt="Logo"
          style={{ width: "100%", height: "auto", maxWidth: "120px" }}
        />
      </div>
    </div>
  );
};

export default Logo;
